<script setup lang="ts">
// Public shell — WTA-style floating nav on the green page wash, breadcrumb bar on
// inner pages, then the page content + footer (doc 04 §9.1).
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'
import PublicTopNav from '@/components/layout/PublicTopNav.vue'
import PublicBreadcrumb from '@/components/layout/PublicBreadcrumb.vue'
import PublicJoinCta from '@/components/layout/PublicJoinCta.vue'
import PublicFooter from '@/components/layout/PublicFooter.vue'

const route = useRoute()
const auth = useAuthStore()
// The home hero is full-bleed; everywhere else gets the breadcrumb trail.
const showBreadcrumb = computed(() => route.name !== 'home')
// Join CTA before the footer — guests only, and not on home (which has its own).
const showJoinCta = computed(
  () => route.name !== 'home' && !auth.isAuthenticated,
)
</script>

<template>
  <div class="cpa-public cpa-page-bg">
    <PublicTopNav />
    <PublicBreadcrumb v-if="showBreadcrumb" />
    <v-main class="cpa-public__main">
      <slot />
    </v-main>
    <PublicJoinCta v-if="showJoinCta" />
    <PublicFooter />
  </div>
</template>

<style scoped>
.cpa-public {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.cpa-public__main {
  flex: 1 1 auto;
}
</style>
